/**
 * Tres Commas scheduled bank pulls: auto pull target.
 * For Media Devoted | Created By Ciro Autiero
 */

import { matchTracker, type AutoPullResource, type TrackerId } from '@trafficpulse/shared';

const LEGACY = { url: '/banks/auto-pull', key: ['banks', 'auto-pull'] as const };
const TC = { url: '/tres-commas/banks/auto-pull', key: ['tres-commas', 'banks', 'auto-pull'] as const };

/** No tracker argument preserves the existing shared Voluum/Binom endpoint and key. */
export function autoPullTarget(tracker?: TrackerId) {
  if (!tracker) return LEGACY;
  return matchTracker<typeof LEGACY | typeof TC>(tracker, { voluum: () => LEGACY, binom: () => LEGACY,
    'tres-commas': () => TC });
}

export function autoPullDescription(resource: AutoPullResource, tracker?: TrackerId): string {
  const name = tracker ? matchTracker(tracker, { voluum: () => 'Voluum & Binom',
    binom: () => 'Voluum & Binom', 'tres-commas': () => 'Tres Commas' }) : 'Voluum & Binom';
  return resource === 'network-rules'
    ? `Pulls from ${name} on a schedule — new networks are added with the pull currency; existing network rules only get their name updated (currencies and params are never changed)`
    : `Pulls from ${name} on a schedule (update mode)`;
}
